import { Ref, ref, watch } from 'vue'

export const useScrollIntersectionObserver = (
  entryRef: Readonly<Ref<HTMLElement | null>>,
): Ref<boolean> => {
  const itemIsVisible = ref<boolean>(false)

  const intersectionObserver = new IntersectionObserver(entry => {
    const item = entry[0]
    if (!item) return
    itemIsVisible.value = item.isIntersecting
  })

  watch(entryRef, () => {
    const item = entryRef.value
    if (!(item instanceof Element)) return
    intersectionObserver.observe(item)
  })

  return itemIsVisible
}
